import { HygieneScoreValueMapping, OralScores } from 'consts/oralScoreConsts'
import { getPresentedHygieneCategory } from 'logic/oralScoresLogic'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

const OralHygieneScoreToAnalysisMessage = {
  [OralScores.Bad]: 'pages.patients.selectedPatient.hiTagScan.aiScanAnalysis.oralHygiene.messages.payAttention',
  [OralScores.Fair]: 'pages.patients.selectedPatient.hiTagScan.aiScanAnalysis.oralHygiene.messages.fair',
  [OralScores.Good]: 'pages.patients.selectedPatient.hiTagScan.aiScanAnalysis.oralHygiene.messages.good',
  [OralScores.Excellent]: 'pages.patients.selectedPatient.hiTagScan.aiScanAnalysis.oralHygiene.messages.Excellent'
}

export default ({ scanSummaryData }) => {
  const { t } = useTranslation()

  const scanParsedScanSummaryData = JSON.parse(scanSummaryData || '{}')

  const scanOralHygieneScore = useMemo(
    () =>
      getPresentedHygieneCategory({
        ...(scanParsedScanSummaryData?.oral_scores_dict || {}),
        ...(scanParsedScanSummaryData?.oral_scores_presented || {})
      }) || null,
    [scanParsedScanSummaryData?.oral_scores_dict, scanParsedScanSummaryData?.oral_scores_presented]
  )

  const oralHygieneAnalysis = HygieneScoreValueMapping[scanOralHygieneScore]
  const oralHygieneAnalysisMessage = t(OralHygieneScoreToAnalysisMessage[oralHygieneAnalysis])

  return {
    oralHygieneAnalysis,
    oralHygieneAnalysisMessage
  }
}
